export enum ErrorType {
  VALIDATION = 1,
  BREAKING = 2,
  SERVER = 3,
}

export interface MappedError {
  errorMessage: string;
  errorLabel: string;
  type: ErrorType;
  id: string;
}

export interface ErrorWrapperProps {
  readonly isVisible?: boolean;
}

export interface ErrorsSummedUpProps {
  errors: MappedError[];
  isVisible?: boolean;
}
